import "rhino-editor"
import { monitorAction, monitorError } from "./datadog_monitoring"

function monitoredEditorInput(rhinoEditor) {
  return rhinoEditor.getAttribute("input") || ""
}

function jobPostEditorName(rhinoEditor) {
  const inputName = monitoredEditorInput(rhinoEditor)
  const match = inputName.match(/_(ad_content|how_to_apply_content)(?:_[a-z]{2})?$/)

  return match?.[1] || null
}

document.addEventListener("rhino-before-initialize", (e) => {
  const rhinoEditor = e.target
  const editorName = jobPostEditorName(rhinoEditor)

  // Keep options consistent across all Rhino editor instances.
  rhinoEditor.starterKitOptions = {
    ...rhinoEditor.starterKitOptions,
    rhinoGallery: false,
    rhinoAttachment: false,
    rhinoBubbleMenu: true
  }

  if (editorName) {
    monitorAction("job_post.rhino_editor.initialize_started", {
      pathname: window.location.pathname,
      editor_name: editorName
    })
  }
})

document.addEventListener("rhino-initialize", (e) => {
  const rhinoEditor = e.target
  rhinoEditor.dataset.rhinoInitialized = "true"

  const editorName = jobPostEditorName(rhinoEditor)
  if (!editorName) return

  monitorAction("job_post.rhino_editor.initialized", {
    pathname: window.location.pathname,
    editor_name: editorName
  })
})

document.addEventListener("rhino-initialize-error", (e) => {
  const rhinoEditor = e.target
  rhinoEditor.dataset.rhinoInitializeError = "true"

  const editorName = jobPostEditorName(rhinoEditor)
  if (!editorName) return

  monitorError("Rhino editor failed to initialize", {
    pathname: window.location.pathname,
    editor_name: editorName
  })
})
